
import $ from 'jquery';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

@Component
export default class PaginationMiniComponent extends Vue {

  /* PROP */

  @Prop({default: 0}) private count: number;
  @Prop({default: ''}) private url: string;
  @Prop({default: 10}) private pageSize: number;
  @Prop({default: (page: number, url: string) => {
    //
  }})
  private onClick: (page: number, url: string) => void;

  /* INITIALIZATION */

  private activePage: number = 1;
  private liLength: number = 0;
  private buttonLength: number = 0;

  constructor() {
    super();
  }

  /* COMPUTED */

  private get allPage() {
    const total = Math.ceil(this.count / this.pageSize);
    return Array.from(Array(total), (x, index) => index + 1);
  }

  private get isShowPrevious() {
    if (this.activePage >= 4) {
      return true;
    }
    return false;
  }

  private get isShowPrev() {
    if (this.activePage > 1) {
      return true;
    }
    return false;
  }

  private get widthTotal() {
    return `${(this.liLength + this.buttonLength) * 40 + 20}px`;
  }

  /* WATCHER */

  @Watch('activePage')
  private onActivePageChanged() {
    this.$nextTick(() => {
      this.liLength = $('.PaginationMini>ul>li:not([style*="display: none"])').length;
      this.buttonLength = $('.PaginationMini>button:not([style*="display: none"])').length;
    });
  }

  /* LIFECYCLE */

  private mounted() {
    this.$nextTick(() => {
      this.liLength = $('.PaginationMini>ul>li:not([style*="display: none"])').length;
      this.buttonLength = $('.PaginationMini>button:not([style*="display: none"])').length;
    });
  }

  /* METHOD */

  private clickPage(page: number) {
    this.activePage = page;
    this.onClick(this.activePage, this.url);
  }

  private onLast() {
    this.activePage = this.allPage[this.allPage.length - 1];
    this.onClick(this.activePage, this.url);
  }

  private onNext() {
    this.activePage = this.activePage < this.allPage[this.allPage.length - 1] ? this.activePage + 1 : this.activePage;
    this.onClick(this.activePage, this.url);
  }

  private onPrevious() {
    this.activePage = this.activePage > this.allPage[0] ? this.activePage - 1 : this.activePage;
    this.onClick(this.activePage, this.url);
  }

  private onFirst() {
    this.activePage = this.allPage[0];
    this.onClick(this.activePage, this.url);
  }

  private isShow(page: number) {
    const minPage = this.activePage - 2;
    const maxPage = this.activePage + 2;

    if (this.activePage >= 4) {
      if (page < minPage) {
        return false;
      }

      if (page > maxPage) {
        return false;
      }
    } else {
      if (page > 4) {
        return false;
      }
    }

    return true;
  }
}
